import { render, staticRenderFns } from "./QuestionPassFailDisplay.vue?vue&type=template&id=4502e50f&scoped=true&"
import script from "./QuestionPassFailDisplay.vue?vue&type=script&lang=js&"
export * from "./QuestionPassFailDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4502e50f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/Dan/code/teacher-helper/teacher-helper/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib'
import { VRadio } from 'vuetify/lib'
import { VRadioGroup } from 'vuetify/lib'
installComponents(component, {VDivider,VRadio,VRadioGroup})
